import { createFeatureSelector } from '@ngrx/store';

import { type PageStructureState, PAGE_STRUCTURE_FEATURE_KEY } from './page-structure-feature.reducer';

export const pageStructureState = createFeatureSelector<PageStructureState>(PAGE_STRUCTURE_FEATURE_KEY);
